// @flow

/**
 * Module dependencies.
 */

import { Button } from 'client/components/core/buttons';
import { Col, ColFlex, Row, RowFlex } from 'client/components/core/grid';
import { Link } from 'react-router-dom';
import { colors, units } from 'client/styles';
import { compose } from 'recompose';
import { getLocalizedUrl } from 'client/core/utils';
import { translator } from 'core/utils';
import Content from 'client/components/content';
import Header from 'client/components/header';
import Layout from 'client/components/core/layout';
import PageContent from 'client/components/core/page-content';
import RawHtml from 'react-raw-html';
import React, { Component } from 'react';
import Text from 'client/components/core/type';

/**
 * `Props` type.
 */

type Props = {
  translate: Function
};

/**
 * Export `NotFound`.
 */

class NotFound extends Component {

  /**
   * Props.
   */

  props: Props;

  /**
   * Render.
   */

  render(): React$Element<*> {
    const { translate } = this.props;

    return (
      <PageContent background={colors.shadesOfSand2.pampasDarker}>
        <Header
          short
          title={translate('notFound.title')}
        />

        <Content
          pullTop
          separator
        >
          <RowFlex>
            <ColFlex
              sm={5}
              xs={10}
              xsOffset={1}
            >
              <Layout
                marginBottom={units(3)}
                marginBottomSm={units(5)}
                maxWidth={units(60)}
              >
                <Text.H2
                  color={colors.brandPrimary}
                  marginBottom={units(0)}
                >
                  {translate('notFound.subTitle')}
                </Text.H2>
              </Layout>

              <Row>
                <Col
                  md={9}
                  sm={10}
                  xs={12}
                >
                  <Layout
                    marginBottom={units(3)}
                    marginBottomSm={units(5)}
                  >
                    <Text.Paragraph>
                      <RawHtml.span>
                        {translate('notFound.lead')}
                      </RawHtml.span>
                    </Text.Paragraph>
                  </Layout>

                  <Button
                    element={Link}
                    to={getLocalizedUrl('home')}
                  >
                    {translate('notFound.backButton')}
                  </Button>
                </Col>
              </Row>
            </ColFlex>

            <ColFlex
              md={5}
              xs={6}
              xsHidden
            />
          </RowFlex>
        </Content>
      </PageContent>
    );
  }

}

/**
 * Export `NotFound`.
 */

export default compose(translator())(NotFound);



// WEBPACK FOOTER //
// ../src/client/containers/not-found/index.js